import React, { SetStateAction } from "react";
import { NavigateFunction } from "react-router";
//components
import toast from "components/Toast/dispatch";
import { DistributionCenterListProps } from "../components/DistributionCenterTab/interface";
//interfaces
import { IBatchRequestResponse } from "models/Batch";
import { IQuoteDetailItem } from "models/QuoteDetailItem";

const renderTextAlert = (update?: boolean) => {
  if (update)
    return (<span>Cotação ainda em <strong>processamento</strong>. Para permanecer na cotação clique em <strong>Atualizar status</strong> ou <strong>Sair</strong> para retornar a grid de cotações.</span>);
  else
    return (<span>Cotação em <strong>processamento</strong>. Para permanecer na cotação clique em <strong>Atualizar status</strong> ou <strong>Sair</strong> para retornar a grid de cotações.</span>);
};

export const renderAlertUpdatedStatus = (navigate: NavigateFunction, checkStatusQuotation: () => void, update?: boolean) => {
  toast.yesNoCustom(
    "Atenção",
    renderTextAlert(update),
    checkStatusQuotation,
    undefined,
    48,
    "Atualizar status",
    'Sair',
    undefined,
    undefined,
    353,
    undefined,
    undefined,
    () => navigate('/cotacoes-dashboard')
  );
};

export const newTabsOrderWithSegments = (
  newTabs: DistributionCenterListProps[],
  distributionCenterSelected: string,
  setDistributionCenterSelected: (value: SetStateAction<string>) => void,
  setHasMore: (value: SetStateAction<boolean>) => void,
  setCurrentPage: (value: SetStateAction<number>) => void,
  setQuoteItem: (value: SetStateAction<IBatchRequestResponse<IQuoteDetailItem> | undefined>) => void,
  setRemoveAllFromToSegment: (value: SetStateAction<boolean>) => void,
  oldTabs?: DistributionCenterListProps[]
) => {
  const indexOldSegmentSelected = newTabs.find(x => x.distributionCenter === distributionCenterSelected);

  if (oldTabs?.length !== newTabs.length && newTabs[0].distributionCenter !== distributionCenterSelected || ((oldTabs?.length === newTabs.length) && (oldTabs[0].distributionCenter !== newTabs[0].distributionCenter)) || !indexOldSegmentSelected) {
    setDistributionCenterSelected(newTabs[0].distributionCenter);
    setHasMore(true);
    setCurrentPage(0);
    setQuoteItem(undefined);
    setRemoveAllFromToSegment(true);
  }
};